import {
  FIELD_ERROR_TEXT_CLASS,
  FIELD_LABEL_CLASS,
  getErrorMessage,
  getFieldClass,
} from "./inputStyles";

const TextAreaInput = ({
  className,
  defaultValue,
  error,
  label,
  name,
  value,
  required = false,
  register,
  readOnly = false,
  disabled = false,
  placeholder = "",
  rows = 4,
  maxLength = 250,
  ...props
}) => {
  const errorMessage = getErrorMessage(error);

  return (
    <div className={`w-full ${className || ""}`}>
      {label ? (
        <label className={FIELD_LABEL_CLASS} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <textarea
        id={name}
        className={getFieldClass(Boolean(error), "resize-y")}
        placeholder={placeholder}
        {...(register && name ? register(name, { required }) : {})}
        value={value}
        defaultValue={defaultValue}
        readOnly={readOnly}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        {...props}
      />
      {errorMessage ? (
        <small className={FIELD_ERROR_TEXT_CLASS}>{errorMessage}</small>
      ) : null}
    </div>
  );
};

export default TextAreaInput;
